if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.enableDesktopDrag();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      enableDesktopDrag() {
        const viewer = this.elements.viewer;
        if (!viewer) return;

        let start = null;
        let blockClickUntil = 0;

        const canDrag = () =>
          this.mql.matches &&
          (this.dataset.desktopLayout || '').includes('thumbnail');

        viewer.addEventListener('dragstart', (event) => {
          if (canDrag() && event.target.closest('.product__modal-opener--image')) {
            event.preventDefault();
          }
        });

        viewer.addEventListener('pointerdown', (event) => {
          if (!canDrag() || event.pointerType !== 'mouse' || event.button !== 0) return;

          const image = event.target.closest('.product__modal-opener--image');
          if (!image) return;

          const media = image.closest('[data-media-id]');
          if (!media) return;

          start = {
            x: event.clientX,
            y: event.clientY,
            pointerId: event.pointerId,
            media,
          };
        });

        window.addEventListener('pointerup', (event) => {
          if (!start || event.pointerId !== start.pointerId) return;

          const gesture = start;
          start = null;

          const distanceX = event.clientX - gesture.x;
          const distanceY = event.clientY - gesture.y;

          if (
            !canDrag() ||
            Math.abs(distanceX) < 50 ||
            Math.abs(distanceX) <= Math.abs(distanceY)
          ) return;

          blockClickUntil = Date.now() + 400;

          const images = Array.from(
            viewer.querySelectorAll('[data-media-id]')
          ).filter((item) =>
            item.querySelector('.product__modal-opener--image')
          );

          const currentIndex = images.indexOf(gesture.media);
          if (currentIndex < 0 || images.length < 2) return;

          const direction = distanceX < 0 ? 1 : -1;
          const nextIndex =
            (currentIndex + direction + images.length) % images.length;

this.slideDesktopMedia(images[nextIndex].dataset.mediaId, direction);
        });

        window.addEventListener('pointercancel', () => {
          start = null;
        });

        window.addEventListener('blur', () => {
          start = null;
        });

        viewer.addEventListener('click', (event) => {
          if (Date.now() < blockClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      }
      slideDesktopMedia(mediaId, direction) {
        const viewer = this.elements.viewer;
        const nextMedia = viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!nextMedia) return;

        this.desktopSlideAnimation?.cancel();
        this.setActiveMedia(mediaId, false);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        const list = nextMedia.parentElement;
        const previousOverflow = list.style.overflow;
        list.style.overflow = 'hidden';

       const animationTarget =
  nextMedia.querySelector('.product__modal-opener--image') || nextMedia;

const animation = animationTarget.animate(

          [
            {
              transform: `translateX(${direction > 0 ? '100%' : '-100%'})`,
              opacity: 0.6,
            },
            {
              transform: 'translateX(0)',
              opacity: 1,
            },
          ],
          {
            duration: 350,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          }
        );

        this.desktopSlideAnimation = animation;

        const cleanUp = () => {
          list.style.overflow = previousOverflow;
          if (this.desktopSlideAnimation === animation) {
            this.desktopSlideAnimation = null;
          }
        };

        animation.onfinish = cleanUp;
        animation.oncancel = cleanUp;
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
